import createLucideIcon from '../createLucideIcon';

const ChevronsUp = createLucideIcon('ChevronsUp', [
  ['polyline', { points: '17 11 12 6 7 11', key: '1u9xa9' }],
  ['polyline', { points: '17 18 12 13 7 18', key: '1fl4au' }],
]);

export default ChevronsUp;
